import { bootstrapApplication } from '@angular/platform-browser';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appRoutes } from './app/app.routes'; // ✅ ชื่อถูกต้องแล้ว
import { importProvidersFrom } from '@angular/core'; // ✅ เพิ่ม LOCALE_ID

import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { disableConsoleInProduction } from './app/core/utils/disable-console-in-production';
import { httpDebugLogInterceptor } from './app/core/logging/http-debug-log.interceptor';
import { provideRouteDebugLog } from './app/core/logging/route-debug-log.provider';

disableConsoleInProduction();

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(
      withInterceptors([httpDebugLogInterceptor])
    ),
    provideRouteDebugLog(),
    provideAnimations(),
  ]
})
